module.exports = __webpack_public_path__ + "static/media/Income.6115ab44.svg";